import React from 'react'
import { FooterWow } from '@shared/components/footer'
import { PageLayout } from '@shared/components/page-layout'
import { PageLayoutOwnProps } from '@shared/components/page-layout/model'
import { Empty } from '@shared/models'
import { NextPageFC } from '@shared/models/next-fc'
import { PagesPath, pagesTitles } from 'data/pages-titles'

import { PoluchiteBezBankov } from '../screens/poluchite-bez-bankov'

const poluchiteBezBankov: NextPageFC<Empty, PageLayoutOwnProps> = () => PoluchiteBezBankov()

poluchiteBezBankov.layout = PageLayout

poluchiteBezBankov.layoutProps = {
	menuProps: {
		hideLinksList: true,
	},
	customFooter: <FooterWow extraContent={['']} />,
}

poluchiteBezBankov.headProps = {
	canonicalLink: 'https://credit.club/personal/pomosch-v-poluchenii-kredita',
	title: pagesTitles[PagesPath.poluchiteBezBankov].title,
	description:
		'От 200 тысяч рублей ► Конкурентная ставка ► До 2 млн в день обращения ► Без скрытых комиссий и платежей',
	ogImageName: 'wow.jpg',
}

export default poluchiteBezBankov
